module.exports = __webpack_public_path__ + "media/images/webinar/bitterman-3bb189fa82f439dca2bd372d76240ee5.jpg";